let baseUrl = document.head.querySelector("[property~=base-url][content]").content

if (window.location.href.indexOf('3000') > -1) {
  baseUrl = baseUrl + ':3000'
}

export default {
  baseUrl : baseUrl,
  csrfToken : document.head.querySelector("[property~=csrf-token][content]").content,
};
